import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalCancel: {
    description: 'Generic cancel button label for modals',
    defaultMessage: 'Cancel',
    id: '4aygKJ',
  },
  modalClose: {
    description: 'Close button title for modal header',
    defaultMessage: 'Close',
    id: '0khGoc',
  },
});
